import React, { useRef, useState, useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { Col, Row } from "antd";
import { rol_captura_valOrg, rol_consulta_valOrg } from "../../../utils/ValOrganizacion/roles";
import { getOrganizacionesValidacion } from "../../../api/validacionOrg";
import TableValOrg from "../../../components/Admin/ValOrganizacion/TableValOrg";
import { MOD_VALIDA_ORG } from "../../../utils/constanst";
import { validaModuloAbierto } from "../../../components/Generals/functions";

function ValOrg(props) {
    const { proceso: { proceso, estado } } = props;
    const { user: { rolUsuario }, } = useAuth(); //Se obtiene el rol del usuario
    const isMounted = useRef(true); //Referencia que permite verificar si el componente esta visible
    const [rolModulo, setRolModulo] = useState({}); //Hook para almacenar los permisos
    const [moduloAbierto, setModuloAbierto] = useState(false); //Para validar si el módulo esa abierto o cerrado
    const [organizaciones, setOrganizaciones] = useState({ data: [], loading: false });

    //useEffect que valida que el componente este seleccionado de lo contrario cancela cualquier subcripción
    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);
    //useEffect para validar rol del usuario
    useEffect(() => {
        //Valida los permisos que tienen el usuario
        let captura = false;
        //Devuelve un true si cuenta con los permisos
        captura = rol_captura_valOrg.includes(rolUsuario);
        isMounted.current && setRolModulo(() => ({ captura })); //Se almacenan en el hook
    }, [rolUsuario]);
    //useEffect principal para cargar la pantalla inicial
    useEffect(() => {
        if(proceso) {
            setModuloAbierto(validaModuloAbierto(MOD_VALIDA_ORG)); //PENDIENTE HASTA DEFINIR EL IDMODULO
            setOrganizaciones({ loading: true }); //Se habilita loading de la tabla
            getOrganizacionesValidacion(proceso.idProcesoElectoral).then((res) => {
                if(isMounted.current) {
                    const dataSource = [];
                    res.data.organizaciones.map((org, index) => {
                        return dataSource.push({
                            key: index,
                            indice: index + 1,
                            ...org,
                        });
                    });
                    //Si tienen seleccionado un estado lo quitamos del arreglo de organziaciones 
                    if(estado !== undefined && estado !== null) {
                        if(estado.idEstado !== 0) {
                            for(let i = 0; i < dataSource.length; i++) {
                                if(dataSource[i].idEstado !== estado.idEstado) {
                                    dataSource.splice(i, 1);
                                }
                            }
                        }
                    }
                    setOrganizaciones({ data: dataSource, loading: false }); //Se almacenan en el hook
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [proceso, estado]);

    //Se valida que el usuario tenga al menos el permiso de consultar
    if (!rol_consulta_valOrg.includes(rolUsuario)) {
        return <Redirect to={"/admin/home"} />;
    }

    return (
        <div>
            <Row>
                <Col span={24}>
                    <h1>Validación de solicitudes de organizaciones</h1>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <TableValOrg data={organizaciones.data}
                        loading={organizaciones.loading}
                        rolModulo={rolModulo}
                        moduloAbierto={moduloAbierto}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default withRouter(ValOrg);